import { render, staticRenderFns } from "./DeviceSummary.vue?vue&type=template&id=50c90bec&scoped=true"
import script from "./DeviceSummary.vue?vue&type=script&lang=js"
export * from "./DeviceSummary.vue?vue&type=script&lang=js"
import style0 from "./DeviceSummary.vue?vue&type=style&index=0&id=50c90bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c90bec",
  null
  
)

export default component.exports